document.addEventListener('DOMContentLoaded', function () {
    const navbar = document.querySelector('.juv-navbar');
    const pageWrapper = document.querySelector('.page-wrapper');

    if (!navbar) return;

    function updateNavbar(scrollTop) {
        navbar.classList.toggle('scroll', scrollTop > 0);
    }

    window.addEventListener('scroll', function () {
        updateNavbar(window.scrollY);
    });

    if (pageWrapper) {
        pageWrapper.addEventListener('scroll', function () {
            updateNavbar(pageWrapper.scrollTop);
        });
    }
});